import { useEffect, useRef } from 'react';
var useInitialRender = function useInitialRender() {
  var isInitialRender = useRef(true);
  useEffect(function () {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    }
  }, []);
  return isInitialRender.current;
};
export default useInitialRender;